const pic = (picId: string): string => `image:pictures/${picId}`;

export const PictureComponent = ({
  pictureId,
  alt = '',
  className = '',
  width,
  height,
  style,
  onClick,
}: PictureComponentProps) => {
  return (
    <img
      onClick={onClick}
      style={style}
      width={width}
      height={height}
      className={`twic pic ${className}`}
      data-src={pic(pictureId)}
      src="https://staycation.twic.pics/v1/placeholder:transparent"
      alt={alt}
    />
  );
};

export type PictureComponentProps = {
  pictureId: string;
  className?: string;
  alt?: string;
  width?: number;
  height?: number;
  style?: { [key: string]: string };
  onClick?: (event: React.MouseEvent<HTMLImageElement>) => void;
};
